<template>
  <div data-type="_mgwidget" :data-widget-id="type.id"></div>
</template>

<script>
import { defineComponent, onMounted } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'idealmedia',
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const modes = {
      feed: {
        id: '1785214',
      },
      stnWidget: {
        id: '1786074',
      },
      widget: {
        id: '1785217',
      },
    };

    onMounted(() => {
      // console.log('props.mode', props.mode);
    });

    return { type: modes[props.mode] };
  },
});
</script>
